import { createContext, Component, Children, useReducer, useMemo, useContext, useRef } from 'react';
import propTypes from 'prop-types';
import { jsx } from 'react/jsx-runtime';

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var WistiaContext = /*#__PURE__*/createContext();

function isUndefined(value) {
  return value === undefined;
}

// Serializing React props to wistia class option syntax is generally similar to
// serializing query parameters except that the member delimiter is whitespace
// rather than ampersand. Keys are fixed, whitelisted values that we know do not
// need URI encoding.
//
// The videoFoam option is a unique case because its value can be JSON. To
// account for this, if the key is videoFoam and the value is an object, we
// assume it should be serialized to JSON rather than coerced to string as we do
// for all other values.

function serializeOptionEntry(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  if (key === 'videoFoam' && Object(value) === value) {
    value = JSON.stringify(value);
  }
  return "".concat(key, "=").concat(encodeURIComponent(value));
}

var CHANNEL_OPTION_KEYS = new Set(['embedHost', 'hashedId', 'height', 'heroImageAspectRatio', 'heroImageUrl', 'id', 'mode', 'width']);
var WistiaChannel = /*#__PURE__*/function (_Component) {
  _inherits(WistiaChannel, _Component);
  var _super = _createSuper(WistiaChannel);
  function WistiaChannel() {
    var _this;
    _classCallCheck(this, WistiaChannel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      safeToRender: false
    });
    return _this;
  }
  _createClass(WistiaChannel, [{
    key: "classNames",
    get: function get() {
      return "".concat(this.embedClassNames, " ").concat(this.optionsAsCSSClassNames);
    }
  }, {
    key: "embedClassNames",
    get: function get() {
      return "wistia_channel wistia_async_".concat(this.props.hashedId);
    }
  }, {
    key: "optionsAsCSSClassNames",
    get: function get() {
      return Object.entries(this.props).filter(isWistiaChannelOptionEntry).map(serializeOptionEntry).join(' ');
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        safeToRender: true
      });
      this.context.dispatch({
        type: 'prepare-for-channel',
        payload: {
          hashedId: this.props.hashedId
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$context;
      // SSR doesn't call methods like componentDidMount, so it's crucial that we add the channel
      // to head manager here in render as well in componentDidMount.
      // It would also be incorrect to call dispatch inside the render method, so we avoid doing that and
      // instead use the bound head manager methods directly
      (_this$context = this.context) === null || _this$context === void 0 || (_this$context = _this$context.wistiaContext) === null || _this$context === void 0 || _this$context.addChannelId(this.props.hashedId);
      return this.state.safeToRender ? /*#__PURE__*/jsx("div", {
        className: this.classNames,
        id: this.props.id
      }, this.props.hashedId) : null;
    }
  }]);
  return WistiaChannel;
}(Component);

////////////////////////////////////////////////////////////////////////////////
_defineProperty(WistiaChannel, "contextType", WistiaContext);
_defineProperty(WistiaChannel, "defaultProps", {
  mode: 'inline'
});
_defineProperty(WistiaChannel, "propTypes", {
  embedHost: propTypes.string,
  hashedId: propTypes.string.isRequired,
  height: propTypes.number,
  heroImageAspectRatio: propTypes.number,
  heroImageUrl: propTypes.string,
  id: propTypes.string,
  mode: propTypes.string,
  width: propTypes.number
});
function isWistiaChannelOptionEntry(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  return CHANNEL_OPTION_KEYS.has(key) && !isUndefined(value);
}

var DEFAULT_ASPECT_RATIO = 640 / 360;
var PLAYER_OPTION_KEYS = new Set(['autoPlay', 'bigPlayButtonBorderRadius', 'captionsBackgroundColor', 'captionsTextColor', 'captionsTextSize', 'captionsFontFamily', 'captionsBorderRadius', 'chromeless', 'controlBarBorderRadius', 'controlBarDistance', 'controlsVisibleOnLoad', 'doNotTrack', 'email', 'embedHost', 'endVideoBehavior', 'fitStrategy', 'floatingControlBar', 'fullscreenButton', 'googleAnalytics', 'hashedId', 'height', 'hls', 'id', 'idType', 'language', 'muted', 'playbackRateControl', 'playbar', 'playButton', 'playerBorderRadius', 'playerColor', 'playlistLinks', 'playlistLoop', 'playPauseNotifier', 'popover', 'popoverAnimateThumbnail', 'popoverContent', 'popoverOverlayOpacity', 'preload', 'qualityControl', 'qualityMax', 'qualityMin', 'resumable', 'roundedPlayer', 'seo', 'settingsControl', 'silentAutoPlay', 'smallPlayButton', 'stillUrl', 'time', 'videoFoam', 'volume', 'volumeControl', 'width', 'wmode']);
var PLAYER_EVENT_KEYS = new Set(['onAfterReplace', 'onBeforeRemove', 'onBeforeReplace',
// 'onBetweenTimes',
'onCancelFullscreen', 'onCaptionsChange', 'onConversion',
// 'onCrosstime',
'onEnd', 'onEnterFullscreen', 'onHeightChange', 'onLookChange', 'onMuteChange', 'onPause', 'onPercentWatchedChanged', 'onPlay', 'onPlaybackRateChange', 'onSecondChange', 'onSeek', 'onSilentPlaybackModeChange', 'onTimeChange', 'onVolumeChange', 'onWidthChange']);

/**
 * Takes in an event name (one from the list of PLAYER_EVENT_KEYS)
 * and returns an event in the format that Player expects.
 *
 * That is, all lowercase without the "on" prefix.
 *
 * @param {string} event
 */
function normalizeEventForPlayer() {
  var eventKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return eventKey.replace('on', '').toLowerCase();
}
var WistiaPlayer = /*#__PURE__*/function (_Component) {
  _inherits(WistiaPlayer, _Component);
  var _super = _createSuper(WistiaPlayer);
  function WistiaPlayer() {
    var _this;
    _classCallCheck(this, WistiaPlayer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "player", null);
    _defineProperty(_assertThisInitialized(_this), "state", {
      safeToRender: false
    });
    _defineProperty(_assertThisInitialized(_this), "setupPlayerAfterReady", function (player) {
      var _this$context$dispatc, _this$context;
      (_this$context$dispatc = (_this$context = _this.context).dispatch) === null || _this$context$dispatc === void 0 || _this$context$dispatc.call(_this$context, {
        type: 'add-wistia-player',
        payload: {
          player: player,
          hashedId: _this.props.hashedId
        }
      });
      _this.setupEventBindings(player);
    });
    return _this;
  }
  _createClass(WistiaPlayer, [{
    key: "classNames",
    get: function get() {
      return "".concat(this.embedClassNames, " ").concat(this.optionsAsCSSClassNames, " ").concat(this.props.className);
    }
  }, {
    key: "responsivePaddingStyle",
    get: function get() {
      return {
        paddingBottom: 0,
        paddingLeft: 0,
        paddingTop: this.inverseAspectPercent,
        paddingRight: 0,
        position: 'relative'
      };
    }
  }, {
    key: "responsiveWrapperStyle",
    get: function get() {
      return {
        height: '100%',
        left: 0,
        position: 'absolute',
        top: 0,
        width: '100%'
      };
    }
  }, {
    key: "inverseAspectPercent",
    get: function get() {
      return "".concat(1 / this.aspectRatio * 100, "%");
    }
  }, {
    key: "aspectRatio",
    get: function get() {
      if (this.player && this.player.hasData()) {
        return this.player.aspect();
      } else {
        return DEFAULT_ASPECT_RATIO;
      }
    }
  }, {
    key: "cssDisplayValue",
    get: function get() {
      return this.isPopoverLink ? 'inline' : 'inline-block';
    }
  }, {
    key: "computedPopoverContent",
    get: function get() {
      if (this.isPopoverLink) {
        return /*#__PURE__*/jsx("a", {
          href: "#",
          children: this.props.children
        });
      }
      if (this.isPopoverHtml) {
        return this.props.children;
      }
      return null;
    }
  }, {
    key: "cssHeightValue",
    get: function get() {
      return isUndefined(this.props.height) ? '100%' : "".concat(this.props.height, "px");
    }
  }, {
    key: "cssWidthValue",
    get: function get() {
      return isUndefined(this.props.width) ? '100%' : "".concat(this.props.width, "px");
    }
  }, {
    key: "embedClassNames",
    get: function get() {
      return "wistia_embed wistia_async_".concat(this.props.hashedId);
    }
  }, {
    key: "isPopover",
    get: function get() {
      return isUndefined(this.props.popover) ? Children.count(this.props.children) !== 0 : this.props.popover;
    }
  }, {
    key: "isPopoverLink",
    get: function get() {
      return this.props.popoverContent === 'link';
    }
  }, {
    key: "isPopoverHtml",
    get: function get() {
      return this.props.popoverContent === 'html';
    }
  }, {
    key: "computedVideoFoam",
    get: function get() {
      // We expect videoFoam to be present EXCEPT for the following situations:
      // 1) If width or height are set,
      // 2) if popoverContent is set,
      // 3) if videoFoam is explicitly set to false by prop

      var isPopoverContent = this.isPopoverHtml || this.isPopoverLink; /* #1 */
      var hasDimensions = this.props.height || this.props.width; /* #2 */
      var getsVideoFoam = !isPopoverContent && !hasDimensions;
      return isUndefined(this.props.videoFoam) ? getsVideoFoam : this.props.videoFoam;
    }
  }, {
    key: "optionsAsCSSClassNames",
    get: function get() {
      return Object.entries(this.props).filter(isWistiaPlayerOptionEntry).map(serializeOptionEntry).join(' ');
    }
  }, {
    key: "style",
    get: function get() {
      return _objectSpread2({
        display: this.cssDisplayValue,
        height: this.cssHeightValue,
        width: this.cssWidthValue
      }, this.props.style);
    }

    //-- React Lifecycle Methods --//
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isUnmounting = false;
      this.prepareForPlayerSetup(this.props.hashedId);
      this.context.dispatch({
        type: 'prepare-for-player',
        payload: {
          hashedId: this.props.hashedId
        }
      });
      this.setState({
        safeToRender: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.hashedId !== prevProps.hashedId) {
        this.player.replaceWith(this.props.hashedId);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$player;
      this._isUnmounting = true;
      this.removeEventBindings(this.player);
      (_this$player = this.player) === null || _this$player === void 0 || _this$player.remove();
      this.context.dispatch({
        type: 'remove-wistia-player',
        payload: {
          hashedId: this.props.hashedId
        }
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.hashedId !== this.props.hashedId) {
        return true;
      }
      return !this.state.safeToRender;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$context2;
      // SSR doesn't call methods like componentDidMount, so it's crucial that we add the video
      // to head manager here in render as well in componentDidMount.
      // It would also be incorrect to call dispatch inside the render method, so we avoid doing that and
      // instead use the bound head manager methods directly
      (_this$context2 = this.context) === null || _this$context2 === void 0 || (_this$context2 = _this$context2.wistiaContext) === null || _this$context2 === void 0 || _this$context2.addVideoId(this.props.hashedId);
      if (!this.state.safeToRender) {
        return null;
      }

      // if videoFoam, return a responsive embed, otherwise a fixed embed
      if (this.computedVideoFoam) {
        return /*#__PURE__*/jsx("div", {
          className: "wistia_responsive_padding",
          style: this.responsivePaddingStyle,
          children: /*#__PURE__*/jsx("div", {
            className: "wistia_responsive_wrapper",
            style: this.responsiveWrapperStyle,
            children: /*#__PURE__*/jsx("div", {
              className: this.classNames,
              id: this.props.id,
              style: this.style,
              children: this.isPopover && this.computedPopoverContent
            }, this.props.hashedId)
          })
        });
      } else {
        return /*#__PURE__*/jsx("div", {
          className: this.classNames,
          id: this.props.id,
          style: this.style,
          children: this.isPopover && this.computedPopoverContent
        }, this.props.hashedId);
      }
    }

    //-- Player events --//
  }, {
    key: "onBeforeReplace",
    value: function onBeforeReplace(hashedId) {
      this.removeEventBindings(this.player);
      this.prepareForPlayerSetup(hashedId);
    }

    //-- Helper Methods -- //
  }, {
    key: "removeEventBindings",
    value: function removeEventBindings(player) {
      if (player) {
        PLAYER_EVENT_KEYS.forEach(function (event) {
          player.unbind(normalizeEventForPlayer(event));
        });
        player.unbind('beforereplace');
      }
      window._wq = window._wq || [];
      window._wq.push({
        revoke: this.initConfigOptions
      });
    }
  }, {
    key: "setupEventBindings",
    value: function setupEventBindings(player) {
      var _this2 = this;
      var bindToEvent = function bindToEvent(event, handler) {
        var normalizedEventName = normalizeEventForPlayer(event);
        player.bind(normalizedEventName, function () {
          var _this2$event;
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          // execute handler if it's an event we care about
          (_this2$event = _this2[event]) === null || _this2$event === void 0 || _this2$event.call.apply(_this2$event, [_this2].concat(args));

          // execute handler for event if it was passed in as a prop
          handler === null || handler === void 0 || handler.apply(void 0, args);
        });
      };

      // bind to all possible events that the player emits
      // and forward them off to any functions that may have
      // been passed in as props
      PLAYER_EVENT_KEYS.forEach(function (event) {
        return bindToEvent(event, function () {
          var _this2$props$event, _this2$props;
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }
          return (_this2$props$event = (_this2$props = _this2.props)[event]) === null || _this2$props$event === void 0 ? void 0 : _this2$props$event.call.apply(_this2$props$event, [_this2$props].concat(args));
        });
      });
      if (this.props.customEvents) {
        // bind to any custom events the user may have passed in
        Object.entries(this.props.customEvents).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          bindToEvent(key, value);
        });
      }
    }
  }, {
    key: "prepareForPlayerSetup",
    value: function prepareForPlayerSetup(hashedId) {
      var _this3 = this;
      var handleEvent = function handleEvent(event, player) {
        var _this3$props$event, _this3$props;
        if (_this3._isUnmounting) {
          return;
        }
        (_this3$props$event = (_this3$props = _this3.props)[event]) === null || _this3$props$event === void 0 || _this3$props$event.call(_this3$props, player);
      };
      this.initConfigOptions = {
        id: this.props.id || hashedId,
        onEmbedded: function onEmbedded(player) {
          return handleEvent('onEmbedded', player);
        },
        onHasData: function onHasData(player) {
          _this3.player = player;
          handleEvent('onHasData', player);
        },
        onReady: function onReady(player) {
          handleEvent('onReady', player);
          _this3.setupPlayerAfterReady(player);
        },
        options: this.props.customOptions ? this.props.customOptions : {}
      };
      window._wq = window._wq || [];
      window._wq.push(this.initConfigOptions);
    }
  }]);
  return WistiaPlayer;
}(Component);

////////////////////////////////////////////////////////////////////////////////
_defineProperty(WistiaPlayer, "contextType", WistiaContext);
_defineProperty(WistiaPlayer, "propTypes", {
  autoPlay: propTypes.bool,
  bigPlayButtonBorderRadius: propTypes.number,
  chromeless: propTypes.bool,
  className: propTypes.string,
  captionsBackgroundColor: propTypes.string,
  captionsTextColor: propTypes.string,
  captionsTextSize: propTypes.string,
  captionsFontFamily: propTypes.string,
  captionsBorderRadius: propTypes.number,
  controlBarBorderRadius: propTypes.number,
  controlBarDistance: propTypes.number,
  controlsVisibleOnLoad: propTypes.bool,
  customEvents: propTypes.object,
  customOptions: propTypes.object,
  doNotTrack: propTypes.bool,
  email: propTypes.string,
  embedHost: propTypes.string,
  endVideoBehavior: propTypes.oneOf(['default', 'loop', 'reset']),
  fitStrategy: propTypes.oneOf(['fill', 'contain', 'cover', 'none']),
  floatingControlBar: propTypes.bool,
  fullscreenButton: propTypes.bool,
  googleAnalytics: propTypes.bool,
  hashedId: propTypes.string.isRequired,
  height: propTypes.number,
  hls: propTypes.bool,
  id: propTypes.string,
  idType: propTypes.string,
  language: propTypes.string,
  muted: propTypes.bool,
  playButton: propTypes.bool,
  playbackRateControl: propTypes.bool,
  playbar: propTypes.bool,
  playerBorderRadius: propTypes.number,
  playerColor: propTypes.string,
  playlistLinks: propTypes.string,
  playlistLoop: propTypes.bool,
  playPauseNotifier: propTypes.bool,
  popover: propTypes.bool,
  popoverAnimateThumbnail: propTypes.bool,
  popoverContent: propTypes.oneOf(['link', 'html', 'thumbnail']),
  popoverOverlayOpacity: propTypes.number,
  preload: propTypes.oneOf(['auto', 'metadata', 'none', true, false]),
  roundedPlayer: propTypes.number,
  qualityControl: propTypes.bool,
  qualityMax: propTypes.oneOfType([propTypes.number, propTypes.oneOf(['360p', '540p', '720p', '1080p', '4k'])]),
  qualityMin: propTypes.oneOfType([propTypes.number, propTypes.oneOf(['360p', '540p', '720p', '1080p', '4k'])]),
  resumable: propTypes.oneOf([true, false, 'auto']),
  seo: propTypes.bool,
  settingsControl: propTypes.bool,
  silentAutoPlay: propTypes.oneOf(['allow', true, false]),
  smallPlayButton: propTypes.bool,
  stillUrl: propTypes.string,
  time: propTypes.number,
  videoFoam: propTypes.oneOfType([propTypes.bool, propTypes.shape({
    maxHeight: propTypes.number,
    maxWidth: propTypes.number,
    minHeight: propTypes.number,
    minWidth: propTypes.number
  })]),
  volume: propTypes.number,
  volumeControl: propTypes.bool,
  width: propTypes.number,
  wmode: propTypes.string
});
function isWistiaPlayerOptionEntry(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
    key = _ref4[0],
    value = _ref4[1];
  return PLAYER_OPTION_KEYS.has(key) && !isUndefined(value);
}

// This is the most primitive and generic ToString operation. It differs
// slightly from String(value) in that it refuses to coerce Symbols.

function toString(value) {
  return "".concat(value);
}

// The src comparison is made using HTMLScriptElement.prototype.src rather than
// baking it into the selector because HTMLScriptElement.prototype.src will be
// the canonicalized URL. The serialized HTML src attribute value may not be in
// canonical form.

function addScriptIfAbsent(src) {
  var scripts = Array.from(document.getElementsByTagName('script'));
  var script = Object.assign(document.createElement('script'), {
    src: src
  });
  if (scripts.every(function (existingScript) {
    return existingScript.src !== script.src;
  })) {
    document.head.appendChild(script);
  }
}

var defineProperties = Object.defineProperties;

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors;

// Coerce URL origin string. Allows for but fixes empty pathname and ensures
// canonicalization.

function toOrigin(origin) {
  origin = toString(origin);
  try {
    var url = new URL(origin);
    if (url.href === "".concat(url.origin, "/")) {
      return url.origin;
    }
  } catch (_unused) {}
  throw new URIError("".concat(JSON.stringify(origin), " is not a valid URL origin"));
}

function toURL(url) {
  return new URL(url);
}

var DEFAULT_HREF = location.href ,
  DEFAULT_ORIGIN = 'https://fast.wistia.net';
var CHANNEL_PARAM = 'wgalleryid',
  CHANNEL_VIDEO_PARAM = 'wvideoid',
  LOADER_PARAM = 'e-v1-loader';
var ORIGIN_K = Symbol(),
  URL_K = Symbol();

////////////////////////////////////////////////////////////////////////////////
//
// The HeadManager implementation branches depending on whether we’re in the
// client or in node. The common facets of the API are defined here, and then we
// define the methods with branching implementations after.
//
// Most of this is internal. The addChannelId, addMediaId and finalize methods
// will be exposed indirectly on the WistiaContext object that gets shared from
// <WistiaProvider>.
//
// The user input setters here do not throw, instead logging errors. The guiding
// principle here is that we don’t want an error — whether our own or a user’s —
// to be fatal to rendering, and we’ll try to do as much as we can regardless of
// whether particular functionality cannot be used. On the other hand it’s still
// important to communicate actionable information to developers when something
// isn’t right. For the same reason we log and filter failed API requests but do
// not abort the overall operation.

var HeadManager = /*#__PURE__*/function () {
  function HeadManager(_ref) {
    var _ref$href = _ref.href,
      href = _ref$href === void 0 ? DEFAULT_HREF : _ref$href,
      _ref$origin = _ref.origin,
      origin = _ref$origin === void 0 ? DEFAULT_ORIGIN : _ref$origin;
    _classCallCheck(this, HeadManager);
    _defineProperty(this, ORIGIN_K, DEFAULT_ORIGIN);
    _defineProperty(this, URL_K, undefined);
    _defineProperty(this, "channelIds", new Set());
    _defineProperty(this, "exposedResult", undefined);
    _defineProperty(this, "headResult", undefined);
    _defineProperty(this, "videoIds", new Set());
    this.origin = origin;
    this.url = href;
  }
  _createClass(HeadManager, [{
    key: "activeChannelProjectHashedId",
    get: function get() {
      return this.url && this.url.searchParams.get(CHANNEL_PARAM);
    }
  }, {
    key: "activeChannelVideoHashedId",
    get: function get() {
      return this.url && this.url.searchParams.get(CHANNEL_VIDEO_PARAM);
    }
  }, {
    key: "channelUrl",
    get: function get() {
      return "".concat(this.origin, "/assets/external/channel.js");
    }
  }, {
    key: "hasUrl",
    get: function get() {
      return !isUndefined(this.url);
    }
  }, {
    key: "origin",
    get: function get() {
      return this[ORIGIN_K];
    },
    set: function set(origin) {
      try {
        this[ORIGIN_K] = toOrigin(origin);
      } catch (err) {
        console.error(err);
      }
    }
  }, {
    key: "playerUrl",
    get: function get() {
      return this.shouldUseLoader ? "".concat(this.origin, "/assets/external/E-v1-loader.js") : "".concat(this.origin, "/assets/external/E-v1.js");
    }
  }, {
    key: "shouldUseLoader",
    get: function get() {
      return this.hasUrl && this.url.searchParams.get(LOADER_PARAM) === 'true';
    }
  }, {
    key: "url",
    get: function get() {
      return this[URL_K];
    },
    set: function set(url) {
      try {
        this[URL_K] = toURL(url);
      } catch (err) {
        console.error(err);
      }
    }
  }]);
  return HeadManager;
}();

// BROWSER /////////////////////////////////////////////////////////////////////
//
// In the client, we’re not interested in the IDs themselves, only the fact that
// an embed of a particular type has appeared. The appearance of a channel or
// player necessitates loading the associated Wistia script. The script may have
// been included already during SSR, so we check for its existence before
// appending it. The state (“has already loaded”) is inherently global in the
// client due to the nature of scripts, which is why it is not modeled as part
// of the HeadManager instance.
//
// The finalize method is explicitly defined so that we can clearly communicate
// why it’s not available; if a user is calling it in clientside code, it is a
// signal that their wiring up of the provider is super borked and needs to be
// fixed.

{
  var hasLoadedChannelScript;
  var hasLoadedPlayerScript;
  defineProperties(HeadManager.prototype, getOwnPropertyDescriptors( /*#__PURE__*/function () {
    function _class2() {
      _classCallCheck(this, _class2);
    }
    _createClass(_class2, [{
      key: "addChannelId",
      value: function addChannelId() {
        if (!hasLoadedChannelScript) {
          hasLoadedChannelScript = true;
          addScriptIfAbsent(this.channelUrl);
        }
      }
    }, {
      key: "addVideoId",
      value: function addVideoId() {
        if (!hasLoadedPlayerScript) {
          hasLoadedPlayerScript = true;
          addScriptIfAbsent(this.playerUrl);
        }
      }
    }, {
      key: "finalize",
      value: function finalize() {
        return Promise.reject(new Error('WistiaContext.finalize is SSR-only'));
      }
    }]);
    return _class2;
  }().prototype));
}

function useHeadManager(_ref) {
  var href = _ref.href,
    origin = _ref.origin;
  var headManager = useRef(new HeadManager({
    href: href,
    origin: origin
  }));
  return headManager.current;
}
var initialState = {
  players: {}
};
function WistiaProvider(props) {
  var children = props.children,
    _props$context = props.context,
    context = _props$context === void 0 ? {} : _props$context,
    href = props.href,
    origin = props.origin;
  var headManager = useHeadManager({
    href: href,
    origin: origin
  });
  function reducer(state, action) {
    switch (action.type) {
      case 'prepare-for-channel':
        {
          headManager === null || headManager === void 0 || headManager.addChannelId(action.payload.hashedId);
          return state;
        }
      case 'prepare-for-player':
        {
          headManager === null || headManager === void 0 || headManager.addVideoId(action.payload.hashedId);
          return state;
        }
      case 'add-wistia-player':
        {
          state.players[action.payload.hashedId] = action.payload.player;
          return _objectSpread2(_objectSpread2({}, state), {}, {
            players: _objectSpread2({}, state.players)
          });
        }
      case 'remove-wistia-player':
        {
          delete state.players[action.payload.hashedId];
          return {
            players: _objectSpread2({}, state.players)
          };
        }
      default:
        {
          throw new Error("Unhandled action type: ".concat(action.type));
        }
    }
  }
  var _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var wistiaContext = useMemo(function () {
    var memoizedContext = _objectSpread2({}, context);
    Object.defineProperties(memoizedContext, _defineProperty({
      addChannelId: {
        value: headManager.addChannelId.bind(headManager),
        writable: true
      },
      addVideoId: {
        value: headManager.addVideoId.bind(headManager),
        writable: true
      },
      finalize: {
        value: headManager.finalize.bind(headManager),
        writable: true
      }
    }, Symbol.toStringTag, {
      value: 'WistiaContext'
    }));
    return memoizedContext;
  }, [context]);
  var value = {
    state: state,
    dispatch: dispatch,
    wistiaContext: wistiaContext
  };
  return /*#__PURE__*/jsx(WistiaContext.Provider, {
    value: value,
    children: children
  });
}

/**
 * A way to access the player API from any component that is a child
 * of a WistiaProvider.
 *
 * @param {string} hashedId - the hashed id of the player you want to use
 */
function usePlayer(hashedId) {
  var context = useContext(WistiaContext);
  if (context === undefined) {
    throw new Error('usePlayer must be used within a WistiaProvider');
  }
  return context.state.players[hashedId];
}

export { PLAYER_OPTION_KEYS, WistiaChannel, WistiaPlayer, WistiaProvider, usePlayer };
